import CircularProgress from '@mui/material/CircularProgress';

// NOTE: Use these only for components which can access full height
// TODO: Fix the height overflow issue

const LoadingSpinner = () => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '80vh',
      }}
    >
      <CircularProgress />
    </div>
  );
};

export default LoadingSpinner;
